export default "__VITE_ASSET__DOt9QAU3__"